import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX, faCircle } from '@fortawesome/free-solid-svg-icons'

export default function DeclineIcon() {
  return (
    <span className="lox-icon-styling-wrapper icon is-small has-text-danger">
      <span
        style={{ pointerEvents: 'auto' }}
        className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-right has-tooltip-primary has-text-weight-normal`}
        data-tooltip={"No or False"}
      >
        <span className="fa-stack fa-xs">
          <FontAwesomeIcon icon={faCircle} className="fa-stack" />
          <FontAwesomeIcon icon={faX} className="fa-stack-1x has-text-white" />
        </span>
      </span>
    </span>
  )
}
